<template>
  <div class="window-height">
    <q-inner-loading showing color="secondary" />
  </div>
</template>

<script lang="ts">
export default {
  mounted() {
    const loginRedirectTo = localStorage.getItem('loginRedirectTo')
    localStorage.removeItem('loginRedirectTo')
    this.$router.push(loginRedirectTo ?? '/')
  }
}
</script>
